module.exports = __webpack_public_path__ + "static/media/WF.d0546857.png";